export default (node) => {
	update();
};

export function update() {
	const el = document.querySelector('.interpolation');
	const images = document.querySelectorAll('.interpolation img');
	const inner = document.querySelector('.interpolation .inner');
	const links = document.querySelectorAll('.js-interpolation-link');
	const main = document.querySelector('main');
	var active = document.querySelector('.interpolation img.active');

	if (!active) {
		active = images[0];
	};

	links.forEach((link, i) => {
		link.addEventListener('mouseover', () => {
			
			if (main.classList.contains('list')) {
				active.classList.remove('active');
				active = images[i];

				const inner_w = inner.offsetWidth;
				const inner_h = inner.offsetHeight;

				const active_w = active.offsetWidth;
				const active_h = active.offsetHeight;

				const offset_x = (100 - (active_w * 100 / inner_w)) / 2;
				const offset_y = (100 - (active_h * 100 / inner_h)) / 2;

				el.style.setProperty('--offset-x', `${offset_x}%`);
				el.style.setProperty('--offset-y', `${offset_y}%`);
				el.classList.add('active');
				active.classList.add('active');
			}
		});

		link.addEventListener('mouseout', () => {
			if (main.classList.contains('list')) {
				el.classList.remove('active');
			}
		})

		link.classList.add('init-fx');
		images[i].classList.add('init-fx');
	});
}
